module.exports = __webpack_public_path__ + "assets/img/url-scan.3a1b99c0.svg";